export const START_CALL = "START_CALL_QUERIES_ADMIN";
export const CALL_COMPLETED = "CALL_COMPLETED_QUERIES_ADMIN";
export const CATCH_ERROR = "CATCH_ERROR_QUERIES_ADMIN";

// commands
export const SELECT_FILTER = "SELECT_FILTER_QUERIES_ADMIN";
export const SET_CHECKBOX_STATE = "SET_CHECKBOX_STATE";
export const UPDATE_CHECKBOX_STATE = "UPDATE_CHECKBOX_STATE";

